import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSidebarIconDashboard = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "dashboard",
	viewBox: "-232 385.9 70 70",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M-197,392.1c-18.2,0-33,14.8-33,33c0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1c0-14.8,12-26.8,26.8-26.8 c14.8,0,26.8,12,26.8,26.8c0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1C-164,407-178.8,392.1-197,392.1z" }), /* @__PURE__ */ _jsx("path", { d: "M-187.9,406.7c-0.3-0.1-0.6-0.1-0.9-0.1c-1.5,0-2.7,1-3.1,2.4l-6,21.9c-3.2,0.3-6.1,2.3-7.5,5.2 c-2.3,4.6-0.4,10.3,4.2,12.6c1.3,0.7,2.7,1,4.2,1c3.6,0,6.8-2,8.4-5.2c1.1-2.2,1.3-4.8,0.5-7.2c-0.6-1.9-1.9-3.6-3.5-4.7l6-21.8 C-185.2,409-186.2,407.2-187.9,406.7z" })]
});
export default SvgSidebarIconDashboard;
